<template>
    <section class="home-contact-cta" dir="rtl" aria-labelledby="home-contact-cta-title">
        <div class="home-contact-cta__visual" aria-hidden="true">
            <div class="home-contact-cta__blob"></div>
            <div class="home-contact-cta__headset">
                <span class="home-contact-cta__ring"></span>
                <span class="home-contact-cta__ring home-contact-cta__ring--delayed"></span>
                <span class="home-contact-cta__headset-circle"><i class="fa fa-headphones"></i></span>
                <span class="home-contact-cta__online"><i></i>پشتیبان آنلاین است</span>
            </div>
            <p>پاسخگویی توسط کارشناسان مجرب</p>
        </div>

        <div class="home-contact-cta__content">
            <p class="home-contact-cta__eyebrow">پشتیبانی و مشاوره تخصصی</p>
            <p id="home-contact-cta-title" class="home-contact-cta__title">یک تماس تا مشاوره تخصصی رایگان</p>
            <p class="home-contact-cta__description">کارشناسان ما آماده‌اند سوالات شما را پاسخ دهند، قیمت دقیق ارائه کنند و سفارشتان را ثبت کنند. کافی است با یکی از شماره‌های زیر تماس بگیرید.</p>

            <div v-if="phoneNumbers.length" class="home-contact-cta__contacts">
                <div v-for="(phone, index) in phoneNumbers" :key="phone" class="home-contact-cta__contact-row">
                    <div class="home-contact-cta__contact-details">
                        <span class="home-contact-cta__phone-icon"><i class="fa fa-phone"></i></span>
                        <span>
                            <a :href="'tel:' + phone" class="home-contact-cta__phone">{{ phone }}</a>
                            <small>{{ index === 0 ? 'تماس با دفتر مرکزی' : 'تماس مستقیم با واحد فروش' }}</small>
                        </span>
                    </div>
                    <button type="button" class="home-contact-cta__copy" :class="{ 'is-copied': copiedPhone === phone }" :aria-label="'کپی شماره ' + phone" @click="copyPhone(phone)">
                        <i :class="copiedPhone === phone ? 'fa fa-check' : 'fa fa-copy'"></i>
                    </button>
                </div>
            </div>

            <a v-if="primaryPhone" :href="'tel:' + primaryPhone" class="home-contact-cta__button">
                <span>همین الان تماس بگیرید</span>
                <i class="fa fa-arrow-left"></i>
            </a>
            <p class="home-contact-cta__hours"><i class="fa fa-clock-o"></i> پاسخگویی همه‌روزه از ۸ صبح تا ۸ شب</p>
            <p class="sr-only" aria-live="polite">{{ copiedPhone ? 'شماره تماس کپی شد' : '' }}</p>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                copiedPhone: null
            };
        },
        computed: {
            phoneNumbers: function () {
                return ['021-88754269', '021-66498541'];
            },
            primaryPhone: function () {
                return this.phoneNumbers.length ? this.phoneNumbers[0] : null;
            }
        },
        methods: {
            copyPhone: function (phone) {
                var component = this;
                var copied = function () {
                    component.copiedPhone = phone;
                    setTimeout(function () {
                        if (component.copiedPhone === phone) {
                            component.copiedPhone = null;
                        }
                    }, 1500);
                };

                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(phone).then(copied).catch(function () {
                        component.copyPhoneFallback(phone, copied);
                    });
                    return;
                }

                this.copyPhoneFallback(phone, copied);
            },
            copyPhoneFallback: function (phone, copied) {
                var textArea = document.createElement('textarea');
                textArea.value = phone;
                textArea.setAttribute('readonly', '');
                textArea.style.position = 'fixed';
                textArea.style.opacity = '0';
                document.body.appendChild(textArea);
                textArea.select();
                try {
                    document.execCommand('copy');
                } catch (error) {
                }
                document.body.removeChild(textArea);
                copied();
            }
        }
    };
</script>

<style scoped>
    .home-contact-cta {
        --cta-red: #da2828;
        --cta-red-dark: #b71f1f;
        --cta-red-deep: #8f1717;
        --cta-ink: #1c1c1c;
        --cta-muted: #767676;
        background: #f4f4f4;
        border-radius: 22px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, .04);
        display: flex;
        margin: 24px auto;
        max-width: 1040px;
        overflow: hidden;
        width: 100%;
    }

    .home-contact-cta__visual {
        align-items: center;
        background: radial-gradient(circle at 30% 20%, rgba(218, 40, 40, .06), transparent 55%), repeating-linear-gradient(135deg, rgba(0, 0, 0, .035) 0 2px, transparent 2px 14px);
        display: flex;
        flex: 0 0 38%;
        flex-direction: column;
        justify-content: center;
        overflow: hidden;
        padding: 40px 24px;
        position: relative;
    }

    .home-contact-cta__blob {
        background: radial-gradient(circle, rgba(218, 40, 40, .16), rgba(218, 40, 40, 0) 70%);
        border-radius: 50%;
        height: 320px;
        pointer-events: none;
        position: absolute;
        right: -80px;
        top: -60px;
        width: 320px;
    }

    .home-contact-cta__headset { height: 220px; position: relative; width: 220px; }
    .home-contact-cta__headset-circle {
        align-items: center;
        background: linear-gradient(145deg, #e6453f, var(--cta-red) 45%, var(--cta-red-deep));
        border-radius: 50%;
        box-shadow: 0 14px 30px rgba(143, 23, 23, .35), inset 0 2px 10px rgba(255, 255, 255, .18), inset 0 -10px 20px rgba(0, 0, 0, .15);
        color: #fff;
        display: flex;
        font-size: 92px;
        height: 220px;
        justify-content: center;
        position: relative;
        width: 220px;
    }

    .home-contact-cta__ring { animation: home-contact-pulse 2.8s ease-out infinite; border: 2px solid var(--cta-red); border-radius: 50%; inset: 0; opacity: 0; position: absolute; }
    .home-contact-cta__ring--delayed { animation-delay: 1.4s; }
    @keyframes home-contact-pulse { 0% { opacity: .55; transform: scale(.86); } 80%, 100% { opacity: 0; transform: scale(1.35); } }
    .home-contact-cta__online {
        align-items: center;
        background: #fff;
        border-radius: 999px;
        bottom: 6px;
        box-shadow: 0 6px 16px rgba(0, 0, 0, .12);
        color: var(--cta-ink);
        display: flex;
        font-size: 11.5px;
        font-weight: 600;
        gap: 6px;
        left: -6px;
        padding: 7px 12px 7px 10px;
        position: absolute;
        white-space: nowrap;
    }
    .home-contact-cta__online i { background: #1ea672; border-radius: 50%; height: 8px; width: 8px; }
    .home-contact-cta__visual > p { background: var(--cta-ink); border-radius: 12px; color: #fff; font-size: 14px; font-weight: 500; margin: 34px 0 0; padding: 12px 22px; position: relative; text-align: center; }

    .home-contact-cta__content { display: flex; flex: 1; flex-direction: column; padding: 44px 48px; }
    .home-contact-cta__eyebrow { color: var(--cta-red); font-size: 14px; font-weight: 800; margin: 0 0 10px; }
    .home-contact-cta__title { color: var(--cta-ink); font-size: 34px; font-weight: 800; line-height: 1.35; margin: 0 0 16px; }
    .home-contact-cta__description { color: var(--cta-muted); font-size: 15px; line-height: 1.9; margin: 0 0 26px; max-width: 480px; text-align: justify; }
    .home-contact-cta__contacts { background: #fff; border-radius: 16px; margin-bottom: 22px; overflow: hidden; }
    .home-contact-cta__contact-row { align-items: center; display: flex; gap: 10px; justify-content: space-between; padding: 14px 16px; }
    .home-contact-cta__contact-row + .home-contact-cta__contact-row { border-top: 1px solid #ededed; }
    .home-contact-cta__contact-details { align-items: center; display: flex; gap: 14px; min-width: 0; }
    .home-contact-cta__phone-icon { align-items: center; background: #fdecec; border-radius: 10px; color: var(--cta-red); display: flex; flex-shrink: 0; height: 38px; justify-content: center; width: 38px; }
    .home-contact-cta__phone, .home-contact-cta__contact-details small { display: block; }
    .home-contact-cta__phone { color: var(--cta-ink); direction: ltr; font-size: 17px; font-weight: 700; text-align: right; unicode-bidi: plaintext; }
    .home-contact-cta__contact-details small { color: var(--cta-muted); font-size: 12px; }
    .home-contact-cta__copy { align-items: center; background: #fff; border: 1px solid #e6e6e6; border-radius: 10px; cursor: pointer; display: flex; flex-shrink: 0; height: 38px; justify-content: center; transition: .2s; width: 38px; }
    .home-contact-cta__copy:hover { background: #fafafa; border-color: #d8d8d8; }
    .home-contact-cta__copy.is-copied { background: #eafbf3; border-color: #beebd8; color: #1ea672; }
    .home-contact-cta__button { align-items: center; background: linear-gradient(135deg, #e6453f, var(--cta-red) 60%, var(--cta-red-dark)); border-radius: 14px; box-shadow: 0 6px 16px rgba(183, 31, 31, .28); color: #fff; display: flex; font-size: 19px; font-weight: 700; justify-content: space-between; margin-bottom: 14px; padding: 6px 6px 6px 26px; text-decoration: none; transition: .25s; }
    .home-contact-cta__button:hover { box-shadow: 0 12px 26px rgba(183, 31, 31, .4); color: #fff; transform: translateY(-2px); }
    .home-contact-cta__button i { align-items: center; background: rgba(255, 255, 255, .28); border-radius: 50%; display: flex; height: 46px; justify-content: center; width: 46px; }
    .home-contact-cta__hours { color: var(--cta-muted); font-size: 13px; margin: 0; padding-right: 165px; }
    .home-contact-cta__hours i { margin-left: 8px; }

    @media (max-width: 760px) {
        .home-contact-cta { flex-direction: column; }
        .home-contact-cta__visual { padding: 40px 24px 32px; }
        .home-contact-cta__content { padding: 32px 26px; }
        .home-contact-cta__title { font-size: 26px; }
        .home-contact-cta__hours { padding-right: 0; }
    }
    @media (prefers-reduced-motion: reduce) { .home-contact-cta__ring { animation: none; } }
</style>
